<sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]=windowHash *ngIf="isLoaded()"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1" *ngIf="isLoaded()">
  <div class="container-fluid m-b-lg ">
    <div class="row m-t-sm ">
      <div class="alert alert-info col-12" role="alert" *ngIf="!this.readonly">
        <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i>{{
          'Documents.export.process.info' | translate }}</span>
      </div>
      <div class="col-12">
        <formElement [model]="exportProcess" [fieldConfig]="getFieldConfig(NAME_FIELD)">
        </formElement>
        <formElement [model]="exportProcess" [fieldConfig]="getFieldConfig(DESCRIPTION_FIELD)">
        </formElement>
        <formElement [model]="exportProcess" [fieldConfig]="getFieldConfig(CONFIGURATIONS_FIELD)">
        </formElement>
        <div class="alert alert-info col-12 {{exportProcess.configuration
          &&exportProcess.configuration.description ?'alert-info':'alert-warning' }}" role="alert"
          *ngIf="!this.readonly">
          <span class="col-12">
            <i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i> {{exportProcess.configuration
            &&exportProcess.configuration.description ?exportProcess.configuration.description:
            'Documents.export.process.messages.configuration1'|translate }} </span>
        </div>
      </div>
      <div class="col-12"
        *ngIf="readonly&&exportProcess.exportResources && exportProcess.exportResources.exportProjectEntities">
        <p-table [value]="exportProcess.exportResources.exportProjectEntities" styleClass="col-12">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 25%">Expediente</th>
              <th style="width: 30%">Documentos seleccionados</th>
              <th style="width: 30%">Documentos exportados</th>
              <th class="action-column">Acciones</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-exportProcessPE>
            <tr>
              <td class="" field="name">{{exportProcessPE.projectEntity.identifier}}</td>
              <td class="text-center" field="name"><span
                  class="badge badge-info">{{exportProcessPE.exportDocuments.length}}</span></td>
              <td class="text-center" field="name"><span class="badge badge-info">{{countExport
                  (exportProcessPE.exportDocuments)}}</span>
              </td>
              <td>
                <div class="btn-group">
                  <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                    (click)="viewAudit(exportProcessPE)">
                    <i class="fa fa-list" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                    (click)="viewDocuments(exportProcessPE)">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</p-scrollPanel>
<p-dialog header="{{'Documents.export.process.audit.title'|translate}}" [(visible)]="displayExportProcessAudit"
  [style]="{'width':'75%'}" [modal]=" true" [appendTo]="'body'" [responsive]="true">
  <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
    <div class="container-fluid m-b-lg ">
      <div class="row m-t-sm ">
        <div class="alert alert-info col-12" role="alert"
          *ngIf="!selectedProjectEntity || !selectedProjectEntity.exportResult">
          <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i>{{
            'General.noData' | translate }}</span>
        </div>
        <ng-container *ngIf="selectedProjectEntity && selectedProjectEntity.exportResult">
          <div class="col-12">
            <p-table #dt [value]="selectedProjectEntity.exportResult.resultMessages" [resizableColumns]="true"
              [responsive]="true" [paginator]="false" dropdownAppendTo="body">
              <ng-template pTemplate="header">
                <tr>
                  <th></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-audit>
                <tr>
                  <td field="name">{{audit}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </ng-container>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>